export default class CapturedField {

  constructor(jsonResponse) {
    if (jsonResponse) {
      this.id = jsonResponse["id"];
      this.requiredFieldId = jsonResponse["required-field-id"];
      this.capturedFieldValue = jsonResponse["captured-field-value"];
      this.transactionId = jsonResponse["transaction-id"];
      this.displayName = jsonResponse["display-name"];
      this.dataType = jsonResponse["data-type"];
    }
  }

}
